export default __webpack_public_path__ + "ceba6d777769ffad3e0d724b91a3691b.png";